import { DEFAULT_TIME_ZONE, localDate } from "./dates.js";

const MONTH_DAY = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "long",
  day: "numeric",
});

const MONTH_DAY_YEAR = new Intl.DateTimeFormat("en-US", {
  timeZone: "UTC",
  month: "long",
  day: "numeric",
  year: "numeric",
});

const asUtcDate = (date) => new Date(`${date}T00:00:00.000Z`);

const longDate = (date) => MONTH_DAY_YEAR.format(asUtcDate(date));

const yearOf = (date) => date.slice(0, 4);

const onOrAround = (date) => `on or around ${longDate(date)}`;

const between = (start, end) => {
  const startText =
    yearOf(start) === yearOf(end)
      ? MONTH_DAY.format(asUtcDate(start))
      : longDate(start);

  return `between ${startText} and ${longDate(end)}`;
};

export const signingDatePhrase = (event) =>
  event.dateType !== "Range"
    ? onOrAround(
        localDate(event.nextEventTime, event.timeZone ?? DEFAULT_TIME_ZONE),
      )
    : event.eventStartDate === event.eventEndDate
    ? onOrAround(event.eventStartDate)
    : between(event.eventStartDate, event.eventEndDate);
